module.exports = __webpack_public_path__ + "static/media/music box.06a9f2bb.mp3";